import {
  IBriefCampaignInfluencerSearchRequestV2,
  ISearchFacets,
} from "@shared/lib/types/briefCampains";
import { SearchMultiSelectFilter } from "@shared/ui/filters/SearchMultiSelectFilter";

interface BriefOpsAssignedFilterProps {
  filters: IBriefCampaignInfluencerSearchRequestV2;
  setFilters: React.Dispatch<
    React.SetStateAction<IBriefCampaignInfluencerSearchRequestV2>
  >;
  confirm: () => void;
  close: () => void;
  pocOptions: ISearchFacets["assignedOperationsPoc"];
}

export function BriefOpsAssignedFilter({
  filters,
  setFilters,
  confirm,
  close,
  pocOptions,
}: BriefOpsAssignedFilterProps) {
  const assignPocs =
    pocOptions?.map((poc) => ({
      label: `${poc.user.firstName} ${poc.user.lastName}`,
      value: poc._id,
    })) || [];

  return (
    <SearchMultiSelectFilter
      confirm={confirm}
      close={close}
      options={assignPocs}
      selectedValues={filters.assignedOperationsPoc || []}
      onApply={(value) => {
        setFilters((prev) => ({
          ...prev,
          assignedOperationsPoc: value,
        }));
      }}
      searchPlaceholder="Search Ops POC"
    />
  );
}

